import React, { FunctionComponent, Fragment } from 'react';
import { Route } from 'react-router-dom';
import { CONTACT, MISCELLANEOUS, SYSTEM_CONFIGURATION_ROUTE } from '../../constants';
import ContactCreate from './containers/ContactCreate';
import ContactEdit from './containers/ContactEdit';
import ContactList from './containers/ContactList';
import ContactView from './containers/ContactView';

interface Props {}

const Contact: FunctionComponent<Props> = () => {
  return (
    <Fragment>
      <Route exact path={`${SYSTEM_CONFIGURATION_ROUTE}${MISCELLANEOUS}${CONTACT}`}>
        <ContactList />
      </Route>
      <Route exact path={`${SYSTEM_CONFIGURATION_ROUTE}${MISCELLANEOUS}${CONTACT}/create`}>
        <ContactCreate />
      </Route>
      <Route exact path={`${SYSTEM_CONFIGURATION_ROUTE}${MISCELLANEOUS}${CONTACT}/edit`}>
        <ContactEdit />
      </Route>
      <Route exact path={`${SYSTEM_CONFIGURATION_ROUTE}${MISCELLANEOUS}${CONTACT}/view`}>
        <ContactView />
      </Route>
    </Fragment>
  );
};

export default Contact;
